import { render, staticRenderFns } from "./ModalReorganizeLocSemence.vue?vue&type=template&id=36b8c2c0&"
import script from "./ModalReorganizeLocSemence.vue?vue&type=script&lang=js&"
export * from "./ModalReorganizeLocSemence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports